export function normalizeFloat(val: number, decimals: number): number {
  if (isNaN(decimals) || !(decimals >= 0 && decimals < 100)) {
    throw new RangeError('decimals Must be a number between 0 and 100');
  }
  if (isNaN(val)) {
    throw new Error('val must be a number');
  }
  const fixedVal = val.toFixed(decimals);
  return Number.parseFloat(fixedVal);
}

export function compareLowFirst(a: number, b: number) {
  if (a > b) {
    return 1;
  }
  if (b > a) {
    return -1;
  }
  return 0;
}

export function parseStrict(value: string): number {
  if (/^(-|\+)?([0-9]+(\.[0-9]+)?|Infinity)$/.test(value)) {
    return Number(value);
  }
  return NaN;
}

export function bigNumberFormat(value: unknown, minimumFractionDigits: number = 0): string {
  if (typeof value === 'object' || isNaN(Number(value))) {
    return `Cannot parse value ${value}`;
  }
  /**
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
   * We can add loads of options but imho creating specific sub-functions dealing with currency or pounds for instance
   */
  const nonBreakingSpace = '\xa0';
  return new Intl.NumberFormat('en-US', { minimumFractionDigits }).format(Number(value)).replace(/,/g, nonBreakingSpace);
}

export function localizedNumberFormat(locale: string, value: unknown, minimumFractionDigits: number = 0) {
  if (typeof value === 'object' || isNaN(Number(value))) {
    return `Cannot parse value ${value}`;
  }

  let lang = 'en-US';
  if (locale === 'fr') {
    lang = 'fr-FR';
  }
  const nonBreakingSpace = '\xa0';
  return new Intl.NumberFormat(lang, { minimumFractionDigits, maximumFractionDigits: 9 }).format(Number(value)).replace(/\s/g, nonBreakingSpace);
}

export function reverseLocalizedFormat(locale: string, value: string) {
  if (locale === 'fr') {
    return value.replace(/\s/g, '').replace(/,/g, '.');
  }
  if (locale === 'en') {
    return value.replace(/,/g, '');
  }
  return '';
}

export function getDecimalSeparator(locale: string) {
  if (locale === 'en') {
    return '.';
  }
  return ',';
}
